<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <g
            fill="none"
            fill-rule="evenodd">
            <path d="M24 0H0v24h24z"></path>
            <path
                class="gst-svg-icon"
                d="m13.707 15.707 3-3a.999.999 0 0 0 0-1.414l-3-3a.999.999 0 1 0-1.414 1.414L13.586 11H8a1 1 0 1 0 0 2h5.586l-1.293 1.293a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0Z"
                fill="#FFF"></path>
        </g>
    </svg>
</template>
<script>
export default {
    name: 'IconSidebarArrow',
};
</script>
